import { immutableSet, removeUndefined, resolveVariablePattern } from '@icp/utils';
import { resolveInitialValues, resolveUrl, selectValues } from '@icp/form-renderer-core';

export const emptyOpenPageRendererProps = {
  // PageRenderer 会默认从路由 params 去取如下参数，打开 Dialog 的时候应该是另一个上下文不应该从路由里取，这里设置 null 实现禁止从路由取
  schemaId: null,
  formEntityToken: null,
  formEntityLayoutToken: null,
  formEntityId: null,
  formEntityLayoutId: null,
  flowToken: null,
  flowDefinitionId: null,
  flowInstanceId: null,
  threadId: null,
  formEntityDataId: null,
};

export function resolveOpenFormProps({
  openFormProps,
  currentData,
  params,
  store,
  response,
  context,
}) {
  const formData = selectValues(store.getState());

  const resolveConfigUrl = (url) => {
    return resolveUrl({ url, store, context, currentData, params, response })[0];
  };

  const resolveConfigVar = (pattern, res = response, failWhenNoVariableValue = false) => {
    return resolveVariablePattern({
      pattern,
      context,
      currentData: currentData || formData,
      formData,
      params,
      response: res,
      failWhenNoVariableValue,
    });
  };

  let openFormPropsResolved = {
    ...emptyOpenPageRendererProps,
    ...removeUndefined({ ...openFormProps }),
  };

  // 开启表单分表过后，需要强制调用 v2 的 api，而 v2 api 需要 formEntityToken,
  // 老的 designer 配置出来没有 formEntityToken，这里补一个，逻辑同 resolveHref 函数
  if (!openFormPropsResolved.formEntityToken && (currentData || formData)?.formEntityToken) {
    openFormPropsResolved.formEntityToken = ':formEntityToken';
  }

  openFormPropsResolved = {
    ...openFormPropsResolved,
    retrieveUrl: resolveConfigUrl(openFormPropsResolved.retrieveUrl),
    createUrl: resolveConfigUrl(openFormPropsResolved.createUrl),
    updateUrl: resolveConfigUrl(openFormPropsResolved.updateUrl),
    formEntityToken: resolveConfigVar(openFormPropsResolved.formEntityToken),
    formEntityDataId: resolveConfigVar(openFormPropsResolved.formEntityDataId),
    flowInstanceId: resolveConfigVar(openFormPropsResolved.flowInstanceId),
    threadId: resolveConfigVar(openFormPropsResolved.threadId),
  };

  if (openFormPropsResolved.FormRendererProps?.defaultData) {
    const resolvedDefaultData = resolveInitialValues({
      defaultValues: openFormPropsResolved.FormRendererProps.defaultData,
      currentData,
      formData,
      context,
      params,
    });
    openFormPropsResolved = immutableSet(
      openFormPropsResolved,
      ['FormRendererProps', 'defaultData'],
      resolvedDefaultData,
    );
  }

  return openFormPropsResolved;
}
